import gql from 'graphql-tag';

const externalGuaranteePurchasesQuery = gql`
  query ExternalGuaranteePurchases(
    $page: Int
    $limit: Int
    $categoryCode: String
    $vin: String
    $dealer: String
  ) {
    externalGuaranteePurchases(
      page: $page
      limit: $limit
      categoryCode: $categoryCode
      vin: $vin
      dealer: $dealer
    ) {
      total
      items {
        externalId
        guaranteeStatus
        vin
        leftLot
        expireGuarantee
        guaranteedAt
        dealerNumber
        auctionCode
        saleNumber
        saleLane
        saleRun
        modelYear
        make
        model
        odometer
        salePrice
        productName
        guaranteePrice
        partner
        paymentKind
        guaranteePurchaseId
      }
    }
  }
`;

export default externalGuaranteePurchasesQuery;
